import { render, staticRenderFns } from "./view-claim.vue?vue&type=template&id=40b5a948"
import script from "./view-claim.vue?vue&type=script&lang=js"
export * from "./view-claim.vue?vue&type=script&lang=js"
import style0 from "./view-claim.vue?vue&type=style&index=0&id=40b5a948&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports